module.exports = __webpack_public_path__ + "pinterest.f04130e0570fdbbedc7bdabb1591b344.svg";